function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocSunsetFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.722 27.83h-6.445v-2h6.445v2zm-2-3H8.277v-2h10.445v2zm5.15-3.004H12.127v-2H23.87v2zM16 10.926c1.836 0 3.563.715 4.86 2.014a6.804 6.804 0 011.933 3.858h7.326v2H1.88v-2h7.328a6.81 6.81 0 011.932-3.858A6.83 6.83 0 0116 10.926zm0 2a4.843 4.843 0 00-3.447 1.428 4.833 4.833 0 00-1.325 2.444h9.542a4.838 4.838 0 00-1.324-2.444A4.84 4.84 0 0016 12.926zm-6.92-2.238l-1.286 1.53h-.001l-3.64-3.057L5.437 7.63l3.642 3.058zm18.768-1.526l-3.643 3.056-1.284-1.531 3.642-3.057 1.285 1.532zm-15.116-.735l-1.811.846-2.009-4.309v-.001l1.812-.845 2.008 4.309zm10.355-3.463l-2.009 4.31-1.811-.846 2.008-4.31 1.812.846zM17 7.924h-2V3.172h2v4.754z",
    fill: props.color
  }));
}

export default SvgIconPocSunsetFilled;